import {
  Components,
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  CssVarsTheme
} from '@mui/material/styles';

export const MuiCard: {
  defaultProps?: ComponentsProps['MuiCard'];
  styleOverrides?: ComponentsOverrides<CssVarsTheme>['MuiCard'];
  variants?: ComponentsVariants['MuiCard'];
} = {
  styleOverrides: {
    root: ({ theme }) => ({
      boxShadow: theme.vars.customShadow.secondary.center,
      borderRadius: 16
    })
  }
};

export const MuiCardContent: Components<CssVarsTheme>['MuiCardContent'] = {
  styleOverrides: {
    root: {
      '&:last-child': {
        paddingBottom: 16
      }
    }
  }
};
